import { apiClient } from "@/lib/apiClient";
import type { CreateVesselResponse } from "@/types/domain";

export function createVessel(imo: number): Promise<CreateVesselResponse> {
  return apiClient.post<CreateVesselResponse>("/api/vessels", { imo });
}
